/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="m13 .9393 2.5303 2.5304a.75.75 0 0 1-1.0606 1.0606l-.7197-.7197v3.2358c2.714.3384 4.8651 2.4895 5.2036 5.2036h3.2357l-.7196-.7197a.75.75 0 0 1 0-1.0606.75.75 0 0 1 1.0606 0L25.0606 13l-2.5303 2.5303a.75.75 0 0 1-1.0606 0 .75.75 0 0 1 0-1.0606l.7196-.7197h-3.2357c-.3385 2.714-2.4896 4.8651-5.2036 5.2036v3.2357l.7197-.7196a.75.75 0 0 1 1.0606 0 .75.75 0 0 1 0 1.0606L13 25.0606l-2.5303-2.5303a.75.75 0 0 1 0-1.0606.75.75 0 0 1 1.0606 0l.7197.7196v-3.2357c-2.714-.3385-4.8651-2.4896-5.2036-5.2036H3.8106l.7197.7197a.75.75 0 0 1-1.0607 1.0606L.9394 13l2.5304-2.5303a.75.75 0 0 1 1.0606 1.0606l-.7197.7197h3.2358C7.3848 9.536 9.536 7.3849 12.25 7.0464V3.8106l-.7197.7197a.75.75 0 0 1-1.0606-1.0607L13 .9394Z"
    clipRule="evenodd"
  />,
  'MenuAllocationResourcesFilled'
);
